import { useEffect, useRef } from 'react';
import './index.scss'
function FormInput(props) {
  const ref = useRef();
  useEffect(() => {
    console.log('FormInput:', props)
    if (!ref.current) return;
    ref.current.value = props.defaultValue || ''
  }, [])
  useEffect(() => {
    if (!ref.current) return;
    ref.current.value = props.defaultValue || ''
    console.log('FormInput props changed:', props)
  }, [props])
  const { children, style, onInput, ...inputProps } = props
  const handleInput = (value) => {
    let val = value
    if (props.onInput) {
      if (Reflect.has(props, 'int')) {
        val = val.replace(/\D/g, '')
      }
      if (!isNaN(Number(val))) {
        if (Reflect.has(props, 'max')) {
          val = Math.min(props.max, val);
        }
        if (Reflect.has(props, 'min')) {
          val = Math.max(props.min, val);
        }
      }
      ref.current.value = val
      props.onInput(val);
    }
  }
  return (
    <div className='dz-input flex-row' style={style}>
      {Reflect.has(props, 'label') && <label className='dz-input-label' style={{ color: !!props.dark ? '#4C5489' : '#fff', width: '150px' }}>{props.label}</label>}
      {children ? children : <input ref={ref} style={{ color: !!props.dark ? '#222' : '#fff' }} onInput={e => handleInput(e.target.value)}  {...inputProps} />}
    </div>
  )
}
export default FormInput;